import { i18n } from '@lingui/core';
import { fr } from 'make-plural/plurals';
import { messages } from './locales/fr/messages';

i18n.loadLocaleData('fr', { plurals: fr });
i18n.load('fr', messages);
i18n.activate('fr');

export { i18n };
